import React from "react";
import "./styles/experienceTimelineContent.css";
import { Link } from "react-router-dom";

const experienceTimelineContent = (props) => {
	const { title, company_url, date, description } = props;
	return (
		<div className="timeline-entry-content">
			<Link to={company_url} target="_blank" className="timeline-entry-title" rel="noopener noreferrer">{title}</Link>
			<p className="timeline-entry-date">{date}</p>
			{description.split("\n").map((data, index) => (
				<p className="timeline-entry-description" key={index}>
					<span>&#8226; </span>
					{data}
				</p>
			))}
		</div>
	);
};

export default experienceTimelineContent;
